module.exports = __webpack_public_path__ + "img/forte0002.b702eb6b.jpeg";